import React from 'react';
import { cloneDeep } from 'lodash';
import { CurrentState } from '../../../common/currentState';
import { OMSModel, travelOMSPassenger, travelOMSVehicle, OMSTowedVehicle } from '../../../common/Models/TravelDetailsViewModel/TravelDetailsViewModel';
import { convertToSentenceCase, isRelocationDateAfterNewChanges } from '../../../utilities';
import TransfreeDetails from '../../../common/Models/TransfreeDetails';

export function travelDetailsInitialized(props) {
    const { relocationTravel } = props;
    const { relocationPlanTravelDetails } = relocationTravel;
    const { RelocationPlanTravelDetails } = relocationPlanTravelDetails;
    return RelocationPlanTravelDetails !== null && RelocationPlanTravelDetails !== undefined;
}

export function passengerNameOption(relocation) {
    const options = [<option value='' key={'pass-please-select'}>Please Select...</option>];
    const { caseTransfereeDetails, relocationPlanDependantDetails } = relocation;
    // 2nd option is the transferee
    options.push(<option value={caseTransfereeDetails.PartyID} key={caseTransfereeDetails.PartyID}>
        {TransfreeDetails.getFullName(caseTransfereeDetails)}
    </option>);
    if (relocationPlanDependantDetails && relocationPlanDependantDetails.RelocationDependents) {
        // add all the dependants
        relocationPlanDependantDetails.RelocationDependents.forEach(dependant => {
            const { Dependant } = dependant;
            const partyId = parseInt(Dependant.PartyID);
            options.push(<option value={partyId} key={partyId}>
                {TransfreeDetails.getFullName(Dependant)}
            </option>)
        });
    }
    return options;
}

export function getRelationship(transferee, relocation) {
    const caseTransfereeId = sessionStorage.getItem("caseTransfereeId");
    const { PartyID, FamilyMemberPartyID, PartyRelatedRoleID } = transferee;
    const comparedId = parseInt(PartyID) === 0 ? FamilyMemberPartyID : PartyID;
    if (parseInt(comparedId) === parseInt(caseTransfereeId)) {
        return 'TRANSFEREE';
    } else {
        const { relatedRoles } = relocation;

        const relocationDate = relocation.relocationPlanAlternateContact.RelocationDetails.RelocationRequiredDate
        const role = relatedRoles.find(role => role.Id === PartyRelatedRoleID);

        if (relocationDate)
        {
            if (isRelocationDateAfterNewChanges(relocationDate)) {
                return role ? role.Description : ''
            }
        }

        return role ? convertToSentenceCase(role.Code) : ''
    }
}

export function getCurrentState(currState) {
    return currState === CurrentState.Added ? CurrentState.Added : CurrentState.Modified;
}

// pass the state and check if all the state are same
export function samePassenger(pastInputs, currInputs) {
    for (let i = 0; i < pastInputs.length; i++) {
        const pastInput = pastInputs[i];
        const currInput = currInputs[i];
        if (pastInput.value !== currInput.value) {
            return false;
        }
    }
    return true;
}

function filterItem(detail, parameters) {
    const filteredDetails = {};
    parameters.forEach(parameter => {
        filteredDetails[parameter] = detail[parameter];
    });
    return filteredDetails;
}

function removeTravelParamaters(relocationPlanTravelDetails) {
    const parameters = ['RelocationPlanID', 'CaseID', 'DefenceCategorisationID', 'IsReturnToAssistUplift', 'ExpectedReturnDate',
        'ExpectedReturnToNewLocationDate', 'ReturnTravelTypeID', 'AlternateTravelContactID', 'ConcurrencyCheck', 'OrderSubTypeID',
        'TravelServices', 'AlternateContact', 'TravelOwnMeans', 'CurrentState'];
    if (relocationPlanTravelDetails) {
        return filterItem(relocationPlanTravelDetails, parameters);
    }
}

function removeTravelServiceParameters(travelService) {
    const parameters = ["RelocationPlanTravelID", "CaseID", "RelocationPlanID", "RelocationPlanServiceSubTypeID", "DepartureDate",
        "DepartingTime", "DepartureCity", "ArrivalDate", "ArrivingTime", "ArrivalCity", "TravelTypeID", "TravelTypeDescription",
        "TravelTypeCode", "ConcurrencyCheck", "Passengers", "RelocationPlanServiceStatusID", "RelocationPlanServiceStatusCode",
        "RelocationPlanServiceStatusDescription", "RelocationPlanServicePurposeID", "RelocationPlanServiceConcurrencyCheck",
        "RelocationPlanServicePurposeDescription", "OrderSubTypeID", "IsVfmScenarioQuoteService", "CurrentState"];
    if (travelService) {
        return filterItem(travelService, parameters);
    }
}

// sort passengers and filter out unnucessary info
function sortPassengers(Passengers, passedParam) {
    if (Passengers && Passengers.length > 0) {
        // 2nd param is for travel service passenger as per previous implementation
        const parameters = passedParam ||
            ["RelocationPlanTravelPassengerID", "RelocationPlanTravelID", "FareTypeID", "FrequentFlyerNumber",
                "ExcessBaggageCount", "DietaryRequirementTypeID", "PartyID", "PartyRelatedRoleID", "PartyRelatedRoleDesc",
                "ConcurrencyCheck", "DateOfBirth", "GenderTypeID", "GenderTypeDescription", "GivenName", "FamilyName",
                "TitleID", "CurrentState"];
        if (Passengers.length > 1) {
            Passengers.sort((a, b) => {
                // from source code:
                // if (tpassenger.PartyID == int.Parse(Session["caseTransfereeId"].ToString()))
                // tpassenger.PartyRelatedRoleID = 0;
                if (a.PartyID !== 0) {
                    if (parseInt(a.PartyID) === parseInt(sessionStorage.getItem('caseTransfereeId'))) {
                        a.PartyRelatedRoleID = 0;
                    }
                } else {
                    if (parseInt(a.FamilyMemberPartyID) === parseInt(sessionStorage.getItem('caseTransfereeId'))) {
                        a.PartyRelatedRoleID = 0;
                    }
                }
                return a.PartyRelatedRoleID - b.PartyRelatedRoleID
            });
        }
        for (let i = 0; i < Passengers.length; i++) {
            const passenger = Passengers[i];
            Passengers[i] = filterItem(passenger, parameters);
        }
    }
}

// as the data contains unnecessary info, it's necessary to clean it up
export function cleanUpTravelDetails(relocation) {
    relocation.RelocationPlanTravelDetails = removeTravelParamaters(relocation.RelocationPlanTravelDetails);
    const { TravelServices, TravelOwnMeans } = relocation.RelocationPlanTravelDetails;
    if (TravelServices) {
        for (let i = 0; i < TravelServices.length; i++) {
            const travelService = TravelServices[i];
            TravelServices[i] = removeTravelServiceParameters(travelService);
            sortPassengers(travelService.Passengers);
        }
    }
    if (TravelOwnMeans) {
        const omsModel = OMSModel(0);
        const omsPassengerModel = travelOMSPassenger();
        const omsVehicleModel = travelOMSVehicle();
        const omsTowedVehicleModel = OMSTowedVehicle();
        for (let i = 0; i < TravelOwnMeans.length; i++) {
            const currentOM = TravelOwnMeans[i];
            TravelOwnMeans[i] = filterItem(currentOM, Object.keys(omsModel));
            const { TravelOwnMeansPassengers, Vehicles } = currentOM;
            sortPassengers(TravelOwnMeansPassengers, Object.keys(omsPassengerModel));
            for (let j = 0; j < Vehicles.length; j++) {
                const vehicle = Vehicles[j];
                Vehicles[j] = filterItem(vehicle, Object.keys(omsVehicleModel));
                if (vehicle.TowedVehicle) {
                    Vehicles[j].TowedVehicle = filterItem(vehicle.TowedVehicle, Object.keys(omsTowedVehicleModel));
                }
            }
        }
    }
}

function parseValueToInt(objectDetails) {
    Object.keys(objectDetails).forEach(key => {
        if (key.toLocaleLowerCase().includes('id')) {
            let parsedInt = parseInt(objectDetails[key]);
            if (isNaN(parsedInt)) {
                parsedInt = 0;
            }
            objectDetails[key] = parsedInt;
        }
    })
}

export function getCopiedRelocationTravel(relocationTravel) {
    const relocationTravelDetails = { ...relocationTravel.relocationPlanTravelDetails };
    parseValueToInt(relocationTravelDetails);
    return relocationTravelDetails;
}

export function getCopiedTravelDetails(relocationTravel) {
    const relocationPlanTravelDetails = getCopiedRelocationTravel(relocationTravel);
    relocationPlanTravelDetails.RelocationPlanTravelDetails = { ...relocationPlanTravelDetails.RelocationPlanTravelDetails };
    parseValueToInt(relocationPlanTravelDetails.RelocationPlanTravelDetails);
    return relocationPlanTravelDetails;
}

export function getCopiedTravelServiceDetails(relocationTravel) {
    const relocationPlanTravelDetails = getCopiedTravelDetails(relocationTravel);
    const { RelocationPlanTravelDetails } = relocationPlanTravelDetails;
    RelocationPlanTravelDetails.TravelServices = [...RelocationPlanTravelDetails.TravelServices];
    RelocationPlanTravelDetails.TravelOwnMeans = [...RelocationPlanTravelDetails.TravelOwnMeans];
    return relocationPlanTravelDetails;
}

export function getCopiedPassengersDetail(relocationTravel) {
    const relocationPlanTravelDetails = getCopiedTravelServiceDetails(relocationTravel);
    const { TravelServices } = relocationPlanTravelDetails.RelocationPlanTravelDetails;
    for (let i = 0; i < TravelServices.length; i++) {
        TravelServices[i] = { ...TravelServices[i] };
        parseValueToInt(TravelServices[i]);
        TravelServices[i].Passengers = [...TravelServices[i].Passengers];
        for (let j = 0; j < TravelServices[i].Passengers.length; j++) {
            const Passengers = TravelServices[i].Passengers;
            Passengers[j] = { ...Passengers[j] };
            parseValueToInt(Passengers[j]);
        }
    }
    return relocationPlanTravelDetails;
}

export function getCopiedOmsDetail(relocationTravel) {
    const relocationPlanTravelDetails = getCopiedTravelServiceDetails(relocationTravel);
    const { TravelOwnMeans } = relocationPlanTravelDetails.RelocationPlanTravelDetails;
    for (let i = 0; i < TravelOwnMeans.length; i++) {
        TravelOwnMeans[i] = { ...TravelOwnMeans[i] };
        parseValueToInt(TravelOwnMeans[i]);

        TravelOwnMeans[i].TravelOwnMeansPassengers = [...TravelOwnMeans[i].TravelOwnMeansPassengers];
        for (let j = 0; j < TravelOwnMeans[i].TravelOwnMeansPassengers.length; j++) {
            const Passengers = TravelOwnMeans[i].TravelOwnMeansPassengers;
            Passengers[j] = { ...Passengers[j] };
            parseValueToInt(Passengers[j]);
        }
        TravelOwnMeans[i].Vehicles = [...TravelOwnMeans[i].Vehicles];
        for (let j = 0; j < TravelOwnMeans[i].Vehicles.length; j++) {
            const vehicle = TravelOwnMeans[i].Vehicles;
            vehicle[j] = { ...vehicle[j] };
            parseValueToInt(vehicle[j]);
        }
    }
    return relocationPlanTravelDetails;
}

export function restorePartyRoleId(relocationTravel) {
    const relocationPlanTravelDetails = cloneDeep(relocationTravel.relocationPlanTravelDetails);
    parseValueToInt(relocationPlanTravelDetails);
    const { TravelServices } = relocationPlanTravelDetails.RelocationPlanTravelDetails;
    TravelServices.forEach(service => {
        const { Passengers } = service;
        Passengers.forEach(passenger => {
            if (parseInt(passenger.PartyID) === parseInt(sessionStorage.getItem('caseTransfereeDetails'))) {
                passenger.PartyRelatedRoleID = 6;
                passenger.PartyRelatedRoleDesc = '';
            }
        })
    })
    return relocationPlanTravelDetails;
}

export function updatePassenger(relocation, passenger, partyId) {
    const { relocationPlanDependantDetails, caseTransfereeDetails } = relocation;
    const { RelocationDependents } = relocationPlanDependantDetails;

    const attributes = ['PartyRelatedRoleID', 'PartyRelatedRoleDesc', 'DateOfBirth', 'GenderTypeID', 'GivenName',
        'FamilyName', 'TitleID'];
    if (!partyId) {
        attributes.forEach(attribute => {
            passenger[attribute] = '';
        })
    }   else if (parseInt(caseTransfereeDetails.PartyID) === parseInt(partyId)) {
        for (let i = 2; i < attributes.length; i++) {
            const attribute = attributes[i];
            passenger[attribute] = caseTransfereeDetails[attribute];
            passenger.PartyRelatedRoleID = 0;
            passenger.PartyRelatedRoleDesc = '';
        }
    } else {
        const dependant = RelocationDependents.find(dependantDetails =>
            parseInt(dependantDetails.Dependant.PartyID) === parseInt(partyId));
        if (dependant) {
            attributes.forEach(attribute => {
                passenger[attribute] = dependant.Dependant[attribute];
            })
        }
    }
}

export function filterService(service) {
    for (let i = 0; i < service.length; i++) {
        if (service[i].CurrentState === CurrentState.Added) {
            service[i] = {};
        } else {
            service[i].CurrentState = CurrentState.Deleted;
        }
    }
    return service.filter(svc => Object.keys(svc).length > 0);
}

export const OMS_SERVICE_TYPE = {
    VEHICLE: 2,
    TRAVELLER: 1,
}

export function modifyInputs(inputList) {
    const updateInputList = cloneDeep(inputList);
    updateInputList.forEach(inputs => {
        inputs.forEach(input => {
            input.modified = true;
        })
    })
    return updateInputList;
}